import {connect} from '../../../../../../../../commons/components/runtime-context/connect'
import {getEvent} from '../../../../../selectors/event'
import {isChooseSeatNoFee} from '../../../../../selectors/navigation'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {WholeElementReservationOwnProps, WholeElementReservationRuntimeProps} from './interfaces'
import {WholeElementReservation as Presentation} from './whole-element-reservation'

const mapRuntime = ({state}: DetailsPageAppProps): WholeElementReservationRuntimeProps => ({
  event: getEvent(state),
  noServiceFee: isChooseSeatNoFee(state),
})

export const WholeElementReservation = connect<WholeElementReservationOwnProps, WholeElementReservationRuntimeProps>(
  mapRuntime,
)(Presentation)
export * from './interfaces'
